import React, { useRef, useMemo } from "react";
import FullCalendar from "@fullcalendar/react";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import googleCalendarPlugin from "@fullcalendar/google-calendar";
import useSwipeWeek from "./useSwipeWeek";
import listPlugin from "@fullcalendar/list";
import dayGridPlugin from "@fullcalendar/daygrid";


function DayCalendar({
  selectedDate,
  setSelectedEvent,
  selectedCalendars,
  googleCalendarApiKey,
}) {
const calendarRef = useRef(null);
const swipeHandlers = useSwipeWeek(calendarRef);
const handleEventClick = (info) => {
  info.jsEvent.preventDefault();

  const eventRect = info.el.getBoundingClientRect();
  const calendarElement = info.el.closest(".fc");

  const calendarRect =
    calendarElement.getBoundingClientRect();

  setSelectedEvent({
    event: info.event,
    x: eventRect.left - calendarRect.left,
    y: eventRect.bottom - calendarRect.top,
  });
};

const eventSources = useMemo(
  () =>
    selectedCalendars.map((calendarId) => ({
      googleCalendarId: calendarId,
    })),
  [selectedCalendars]
);


return (
  <div className="day-calendar-wrapper">

    <div className="day-calendar"   
        {...swipeHandlers}
    >
        <FullCalendar
        ref={calendarRef}
         plugins={[
        dayGridPlugin,
        listPlugin,
        timeGridPlugin,
        interactionPlugin,
        googleCalendarPlugin,
        ]}
        initialView="listDay"
        listDayFormat={{
          weekday: "long",
          day: "2-digit",
          month: "long",
        }}
        initialDate={selectedDate}
        allDaySlot = {false}
        nextDayThreshold="03:00:00"
        headerToolbar = {{
            left: "",
            center: "title",
            right: "",
        }}
        height="auto"
        googleCalendarApiKey={googleCalendarApiKey}

        eventSources={eventSources}
        eventClick={handleEventClick}
        datesSet={() => setSelectedEvent(null)}
      />
      <div>
        <button className="arrow"
      onClick={() =>
        calendarRef.current.getApi().prev()
      }
    >
      ←
    </button>
         swipe to change days
            <button className = 'arrow'
      onClick={() =>
        calendarRef.current.getApi().next()
      }
    >
      →
    </button>
      </div>

    </div>
  </div>
);

}

export default DayCalendar;